














































































































































































































































































































































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import LembarObservasiKebidananStore from "@/store/modules/LembarObservasiAsuhanKebidananStore";
import Service from "@/services/LembarObservasiAsuhanKebidanan";
import {
  LembarObservasiAsuhanKebidanan,
  ObservasiLogItem,
  TandaVitalRingkas,
  TtvKandidatObservasi
} from "@/types/LembarObservasiAsuhanKebidanan";
import {
  computeBishop,
  BishopResult,
  Konsistensi,
  PosisiServiks
} from "@/utils/bishopScore";
import TandaVitalSvc from "@/services/TandaVital";
import VCDateTimePicker from "@/components/form_components/VCDateTimePicker.vue";
import {
  composeDate,
  toDateString,
  toTimeString
} from "@/utils/asesmenIntensifDateTime";

function hhmm(s: unknown): unknown {
  return typeof s === "string" && s.length >= 5 ? s.slice(0, 5) : s;
}

function ttvTanggal(waktu: unknown): string | null {
  const t = String(waktu || "").slice(0, 10);
  return /^\d{4}-\d{2}-\d{2}$/.test(t) ? t : null;
}

function ttvJam(waktu: unknown): string | null {
  const j = String(waktu || "").slice(11, 16);
  return /^\d{2}:\d{2}$/.test(j) ? j : null;
}

function slotKey(tanggal: unknown, jam: unknown): string {
  return `${tanggal || ""} ${hhmm(jam) || ""}`;
}

function num(v: unknown): number | null {
  if (v === null || v === undefined || v === "") return null;
  const n = Number(v);
  return Number.isNaN(n) ? null : n;
}

@Component({
  components: { VCDateTimePicker },
  inject: {
    isReadOnly: { default: () => () => false }
  }
})
export default class LembarObservasiKebidananPage extends Vue {
  @Prop({ required: true }) registerId!: number;
  @Prop({ required: true }) pasienRm!: string;
  @Prop({ default: undefined }) unitId?: string;
  @Prop({ type: Boolean, default: true }) showTtvImport!: boolean;

  isReadOnly!: () => boolean;

  konsistensiOptions = [
    { text: "Keras", value: "firm" },
    { text: "Sedang", value: "medium" },
    { text: "Lunak", value: "soft" }
  ];
  posisiOptions = [
    { text: "Posterior", value: "posterior" },
    { text: "Tengah", value: "mid" },
    { text: "Anterior", value: "anterior" }
  ];

  observasiLog: ObservasiLogItem[] = [];
  jumlahJanin = 1;

  ttvDialog = false;
  ttvLoading = false;
  ttvRows: TandaVitalRingkas[] = [];
  ttvSelected: number[] = [];

  confirmDialog = false;
  confirmMessage = "";
  confirmAction: (() => Promise<void>) | null = null;

  get store() {
    return LembarObservasiKebidananStore;
  }

  get loading(): boolean {
    return this.store.loading;
  }

  get record(): LembarObservasiAsuhanKebidanan | null {
    return this.store.current;
  }

  get bidanSigned(): boolean {
    return !!this.record?.sign?.bidan?.signed;
  }

  get dpjpSigned(): boolean {
    return !!this.record?.sign?.dpjp?.signed;
  }

  get isReadonly(): boolean {
    return this.isReadOnly() || this.bidanSigned;
  }

  get isGemelli(): boolean {
    return Number(this.jumlahJanin) >= 2;
  }

  get djjPlaceholder(): string {
    return this.isGemelli ? "134/156" : "140";
  }

  get ttvCandidates(): TtvKandidatObservasi[] {
    const terpakai = new Set(
      this.observasiLog.map(o => slotKey(o.tanggal, o.jam))
    );

    return this.ttvRows
      .map(r => {
        const tanggal = ttvTanggal(r.waktu_periksa);
        const jam = ttvJam(r.waktu_periksa);
        const sistol = num(r.sistole);
        const diastol = num(r.diastole);

        return {
          id: r.id,
          tanggal,
          jam,
          waktuLabel:
            tanggal && jam
              ? `${tanggal.slice(8, 10)}/${tanggal.slice(5, 7)} ${jam}`
              : "-",
          tdText:
            sistol != null || diastol != null
              ? `${sistol != null ? sistol : ""}/${
                  diastol != null ? diastol : ""
                }`
              : "",
          sistol,
          diastol,
          nadi: num(r.frekuensi_nadi),
          suhu: num(r.suhu_badan),
          rr: num(r.frekuensi_nafas),
          spo2: num(r.saturasi_oksigen),
          sudahAda: terpakai.has(slotKey(tanggal, jam))
        };
      })
      .filter(c => c.tanggal && c.jam)
      .sort((a, b) =>
        slotKey(a.tanggal, a.jam).localeCompare(slotKey(b.tanggal, b.jam))
      );
  }

  get waktuDates(): (Date | null)[] {
    return this.observasiLog.map(o => composeDate(o.tanggal, o.jam));
  }

  setWaktu(idx: number, val: Date | string | null) {
    const row = this.observasiLog[idx];
    if (!row) return;
    const tanggal = toDateString(val);
    if (!tanggal) return;
    row.tanggal = tanggal;
    row.jam = toTimeString(val);
  }

  get bishopRows(): BishopResult[] {
    return this.observasiLog.map(o => this.bishopRow(o));
  }

  // Bishop per-baris (dari pembukaan + VT ringkas). FE preview; server authoritative.
  bishopRow(o: ObservasiLogItem): BishopResult {
    return computeBishop({
      dilatasi_cm: o.pembukaan_cm ?? null,
      effacement_persen: o.vt_effacement_persen ?? null,
      station: o.vt_station ?? null,
      konsistensi: (o.vt_konsistensi ?? null) as Konsistensi | null,
      posisi: (o.vt_posisi ?? null) as PosisiServiks | null
    });
  }

  bishopShort(i: string | null): string {
    if (i === "favorable") return "Matang";
    if (i === "equivocal") return "Intermediate";
    if (i === "unfavorable") return "Belum matang";
    return "";
  }

  bishopColor(r: BishopResult): "success" | "warning" | "error" {
    if (r.interpretasi === "favorable") return "success";
    if (r.interpretasi === "equivocal") return "warning";
    return "error";
  }

  async mounted() {
    if (this.registerId) {
      await this.store.loadByRegister(this.registerId);
      this.hydrateFromRecord();
    }
  }

  hydrateFromRecord() {
    const rec = this.record;
    this.jumlahJanin = Number(rec?.jumlah_janin) >= 2 ? 2 : 1;
    this.observasiLog = Array.isArray(rec?.observasi_log)
      ? rec!.observasi_log!.map((o, i) => ({
          ...o,
          urutan: o.urutan || i + 1,
          jam: hhmm(o.jam) as string
        }))
      : [];
  }

  private todayDate(): string {
    const d = new Date();
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    const dd = String(d.getDate()).padStart(2, "0");
    return `${d.getFullYear()}-${mm}-${dd}`;
  }

  private nowTime(): string {
    const d = new Date();
    const hh = String(d.getHours()).padStart(2, "0");
    const mi = String(d.getMinutes()).padStart(2, "0");
    return `${hh}:${mi}`;
  }

  buildPayload(): Partial<LembarObservasiAsuhanKebidanan> &
    Record<string, any> {
    const rec = this.record;
    return {
      register_id: this.registerId,
      pasien_rm: this.pasienRm,
      unit_id: this.unitId,
      tgl_pengkajian: rec?.tgl_pengkajian || this.todayDate(),
      jam_pengkajian: (hhmm(rec?.jam_pengkajian) as string) || this.nowTime(),
      jumlah_janin: this.jumlahJanin,
      observasi_log: (this.observasiLog || []).map(r => ({
        ...r,
        jam: hhmm(r.jam) as string
      }))
    };
  }

  async save() {
    if (this.isReadonly) return;
    try {
      await this.store.save(this.buildPayload());
      this.hydrateFromRecord();
    } catch (e) {
      // Service already shows error alert.
    }
  }

  signBidan() {
    this.openConfirm(
      "Tanda tangan sebagai Bidan akan mengunci form. Lanjutkan?",
      async () => {
        try {
          await this.store.signBidan();
          this.hydrateFromRecord();
        } catch (e) {
          // error handled by service
        }
      }
    );
  }

  signDpjp() {
    this.openConfirm(
      "Tanda tangan sebagai DPJP akan memverifikasi form. Lanjutkan?",
      async () => {
        try {
          await this.store.signDpjp();
          this.hydrateFromRecord();
        } catch (e) {
          // error handled by service
        }
      }
    );
  }

  openConfirm(message: string, action: () => Promise<void>) {
    this.confirmMessage = message;
    this.confirmAction = action;
    this.confirmDialog = true;
  }

  async runConfirm() {
    const a = this.confirmAction;
    this.confirmDialog = false;
    if (a) {
      await a();
    }
    this.confirmAction = null;
  }

  printPdf() {
    if (!this.record || !this.record.id) return;
    window.open(Service.pdfUrl(this.record.id), "_blank");
  }

  async openTtvDialog() {
    if (this.isReadonly) return;
    this.ttvSelected = [];
    this.ttvLoading = true;
    try {
      const res = await TandaVitalSvc.getByRegister(this.registerId);
      const rows = res && res.data ? res.data : res;
      this.ttvRows = Array.isArray(rows) ? rows : [];
    } catch (e) {
      this.ttvRows = [];
    } finally {
      this.ttvLoading = false;
    }
    this.ttvDialog = true;
  }

  importTtvRows() {
    const dipilih = this.ttvCandidates.filter(
      c => !c.sudahAda && this.ttvSelected.indexOf(c.id) !== -1
    );

    dipilih.forEach(c => {
      this.observasiLog.push({
        urutan: 0,
        tanggal: c.tanggal,
        jam: c.jam,
        infus: null,
        tts: null,
        td_sistol: c.sistol,
        td_diastol: c.diastol,
        nadi: c.nadi,
        suhu: c.suhu,
        rr: c.rr,
        spo2: c.spo2,
        djj: null,
        his: null,
        pembukaan_cm: null,
        vt_effacement_persen: null,
        vt_station: null,
        vt_konsistensi: null,
        vt_posisi: null,
        urine: null,
        perdarahan: null
      });
    });

    this.observasiLog = this.observasiLog
      .slice()
      .sort((a, b) =>
        slotKey(a.tanggal, a.jam).localeCompare(slotKey(b.tanggal, b.jam))
      );
    this.observasiLog.forEach((o, i) => (o.urutan = i + 1));

    this.ttvSelected = [];
    this.ttvDialog = false;
  }

  addObservasiLog() {
    this.observasiLog.push({
      urutan: this.observasiLog.length + 1,
      tanggal: this.todayDate(),
      jam: this.nowTime(),
      infus: null,
      tts: null,
      td_sistol: null,
      td_diastol: null,
      nadi: null,
      suhu: null,
      rr: null,
      spo2: null,
      djj: null,
      his: null,
      pembukaan_cm: null,
      vt_effacement_persen: null,
      vt_station: null,
      vt_konsistensi: null,
      vt_posisi: null,
      urine: null,
      perdarahan: null
    });
  }

  removeObservasiLog(idx: number) {
    this.observasiLog.splice(idx, 1);
    this.observasiLog.forEach((o, i) => (o.urutan = i + 1));
  }
}
